/**
 * ErrorState — error message with retry button
 */

import { createElement } from '../utils/dom.js';

export default class ErrorState {
  /**
   * @param {Object} eventBus - EventBus instance
   * @param {Object} i18n - I18n instance
   */
  constructor(eventBus, i18n) {
    this._eventBus = eventBus;
    this._i18n = i18n;
    this._el = null;
    this._retryCallback = null;
  }

  /**
   * Render the error state
   * @param {HTMLElement} container
   */
  render(container) {
    this._el = createElement('div', 'grb-widget--error');

    this._el.appendChild(
      createElement('div', 'grb-widget--error-title', {}, [this._i18n.t('error.title')])
    );
    this._el.appendChild(
      createElement('div', 'grb-widget--error-text', {}, [this._i18n.t('error.text')])
    );

    const retryBtn = createElement('button', 'grb-widget--error-retry', {
      type: 'button',
    }, [this._i18n.t('error.retry')]);

    retryBtn.addEventListener('click', () => {
      if (this._retryCallback) this._retryCallback();
    });

    this._el.appendChild(retryBtn);
    container.appendChild(this._el);
  }

  /**
   * Set the retry callback
   * @param {Function} cb
   */
  onRetry(cb) {
    this._retryCallback = cb;
  }

  show() {
    if (this._el) this._el.style.display = '';
  }

  hide() {
    if (this._el) this._el.style.display = 'none';
  }

  destroy() {
    if (this._el && this._el.parentNode) {
      this._el.parentNode.removeChild(this._el);
    }
    this._el = null;
    this._retryCallback = null;
  }
}
